// extracted by mini-css-extract-plugin
export var label = "_gl-2";
export var slideContainer = "_gl-0";
export var slider = "_gl-1";